import React from "react";
import HAvatarGroup from "./HAvatarGroup";
import { Constants } from "../utils/constants";
import { MoreVertical, Calendar, MessageSquare, Paperclip } from "lucide-react";

const HPostCard = ({ type, title, description, image, avatars, date, comments, files }) => {
  return (
    <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-100">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-base font-semibold" style={{ color: Constants.HOST_EXPERIENCE_BASE_COLOR }}>
          {type}
        </h3>
        <button className="rounded-full p-1 hover:bg-gray-100">
          <MoreVertical className="w-4 h-4 text-gray-400" />
        </button>
      </div>

      <h4 className="text-gray-900 font-medium text-sm mb-2 leading-tight">{title || description}</h4>

      {image && (
        <div className="mb-3 overflow-hidden rounded-lg">
          <img src={image || "/placeholder.svg"} alt={title} className="h-40 w-full object-cover" />
        </div>
      )}

      <div className="mb-3">
        <HAvatarGroup avatars={avatars} />
      </div>

      <div className="flex items-center gap-4 text-xs text-gray-500">
        <div className="flex items-center gap-1">
          <Calendar className="w-3 h-3" style={{ color: Constants.HOST_EXPERIENCE_BASE_COLOR }} />
          <span>{date}</span>
        </div>
        <div className="flex items-center gap-1">
          <MessageSquare className="w-3 h-3" style={{ color: Constants.HOST_EXPERIENCE_BASE_COLOR }} />
          <span>{comments} Comments</span>
        </div>
        <div className="flex items-center gap-1">
          <Paperclip className="w-3 h-3" style={{ color: Constants.HOST_EXPERIENCE_BASE_COLOR }} />
          <span>{files} Files</span>
        </div>
      </div>
    </div>
  );
};

export default HPostCard;
